var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClimentIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 8,
    viewBox: "0 0 24 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4618_36182)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.8477 6.15523L23.6444 6.15523C23.8408 6.15523 24 5.89709 24 5.57865L24 2.63513C24 2.3235 23.8473 2.06826 23.6552 2.05881L19.5921 1.85908C19.5151 1.8553 19.4409 1.81102 19.3807 1.73293L18.9876 1.22278L18.3097 0.100896C18.2846 0.0593827 18.2503 0.0360314 18.2144 0.0360314L1.39138 0.0360299C1.19502 0.0360299 1.03582 0.294192 1.03582 0.612606L1.03582 6.32037C1.03582 6.63881 1.19502 6.89695 1.39138 6.89695L18.0698 6.89695C18.2042 6.89695 18.3322 6.98996 18.4216 7.15261C18.6388 7.54763 19.0319 7.47375 19.1876 7.00863L19.2948 6.68869C19.4048 6.35994 19.6171 6.15523 19.8477 6.15523Z",
    fill: "#1592D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6197 5.56047L23.6003 5.56047C23.7966 5.56047 23.9558 5.30232 23.9558 4.98389L23.9558 2.11927C23.9558 1.80084 23.7966 1.5427 23.6003 1.5427L19.5719 1.5427C19.4803 1.5427 19.3923 1.48543 19.3261 1.38282L18.9567 0.809961C18.9479 0.796289 18.938 0.784642 18.9272 0.775345L18.2662 0.204894C18.247 0.188246 18.2254 0.179525 18.2036 0.179525L1.34722 0.179523C1.15082 0.179523 0.991662 0.437685 0.991662 0.7561L0.991661 5.70135C0.991661 6.01978 1.15082 6.27792 1.34722 6.27792L18.1879 6.27792C18.2195 6.27792 18.2501 6.2961 18.2742 6.32921L18.6967 6.91008C18.7575 6.99371 18.8498 6.9726 18.8939 6.86493L19.3237 5.81762C19.3896 5.65699 19.5007 5.56047 19.6197 5.56047Z",
    fill: "url(#paint0_linear_4618_36182)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4618_36182)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5 3C19.2239 3 19 3.27705 19 3.61881C19 3.96057 19.2239 4.23763 19.5 4.23763C19.7761 4.23763 20 3.96057 20 3.61881C20 3.27705 19.7761 3 19.5 3Z",
    fill: "#D9D9D9",
    fillOpacity: 0.63
  })), /*#__PURE__*/React.createElement("path", {
    d: "M19.4994 3.23783C19.3295 3.23783 19.1917 3.40833 19.1917 3.61864C19.1917 3.82896 19.3295 3.99945 19.4994 3.99945C19.6694 3.99945 19.8071 3.82896 19.8071 3.61864C19.8071 3.40833 19.6694 3.23783 19.4994 3.23783Z",
    fill: "#062A41"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_4618_36182)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.4604 2.42954C14.9131 2.42954 14.4694 2.83553 14.4694 3.33634C14.4694 3.83716 14.9131 4.24315 15.4604 4.24315C16.0077 4.24315 16.4514 3.83716 16.4514 3.33634C16.4514 2.83553 16.0077 2.42954 15.4604 2.42954Z",
    fill: "#062A41"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_4618_36182)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.4605 2C14.6539 2 14.0001 2.59831 14.0001 3.33635C14.0001 4.0744 14.6539 4.6727 15.4605 4.6727C16.2671 4.6727 16.9209 4.0744 16.9209 3.33635C16.9209 2.59831 16.2671 2 15.4605 2Z",
    fill: "#062A41"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_4618_36182)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.4605 2C14.6539 2 14.0001 2.59831 14.0001 3.33635C14.0001 4.0744 14.6539 4.6727 15.4605 4.6727C16.2671 4.6727 16.9209 4.0744 16.9209 3.33635C16.9209 2.59831 16.2671 2 15.4605 2Z",
    fill: "#062A41"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15.4604 2.42954C14.9131 2.42954 14.4694 2.83553 14.4694 3.33634C14.4694 3.83716 14.9131 4.24315 15.4604 4.24315C16.0077 4.24315 16.4514 3.83716 16.4514 3.33634C16.4514 2.83553 16.0077 2.42954 15.4604 2.42954Z",
    stroke: "#1791D1",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.86 6.83685C18.8581 6.95807 18.7703 7.02147 18.7135 6.94275L18.259 6.31382L18.259 0.0360436C18.5376 0.425233 18.7001 0.398927 18.9563 0.825247L18.86 6.83685Z",
    fill: "url(#paint1_radial_4618_36182)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.70933 4.79898L0.956264 4.81099C0.980887 4.80934 1.00022 4.77633 0.999998 4.73641L0.983508 1.68511C0.982975 1.58719 0.932575 1.50945 0.872264 1.51351L0.600932 1.53175C0.477998 1.54002 0.362176 1.62722 0.278932 1.77412C0.239065 1.84447 0.207865 1.92648 0.186931 2.01578L0.0818207 2.46483C0.0577762 2.56747 0.086441 2.68282 0.147641 2.72971C0.191285 2.76314 0.219865 2.83306 0.221865 2.91123L0.229998 3.23193C0.231998 3.30874 0.206664 3.3806 0.164842 3.41688C0.106753 3.46728 0.0832852 3.58269 0.111419 3.67924L0.316486 4.38213C0.369864 4.56501 0.467687 4.7037 0.586576 4.76502C0.626354 4.78553 0.667641 4.79695 0.70933 4.79898Z",
    fill: "#062A41",
    stroke: "#062A41",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4258 6.13445L23.7219 5.93037L23.7191 5.1481L23.7176 4.73994L23.7099 2.5763L23.7088 2.25706L23.7129 1.57858L23.7792 1.61445L23.8675 1.72207L23.9147 1.85637C23.9416 1.93291 23.9558 2.01942 23.9558 2.10732L23.9558 2.33191L23.7088 2.25706L23.7099 2.5763L23.9431 2.5763L23.9508 4.73994L23.7176 4.73994L23.7191 5.1481L23.9523 5.1481L23.9544 5.7263L23.8074 6.13445L23.4258 6.13445Z",
    fill: "#1592D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0122 6.13445L23.3083 5.93037L23.3055 5.1481L23.3041 4.73994L23.2964 2.5763L23.2952 2.25706L23.2928 1.57682L23.526 1.57682L23.5284 2.25706L23.2952 2.25706L23.2964 2.5763L23.5296 2.5763L23.5373 4.73994L23.3041 4.73994L23.3055 5.1481L23.5387 5.1481L23.5408 5.7263L23.3938 6.13445L23.0122 6.13445Z",
    fill: "#1592D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5984 6.13445L22.8945 5.93037L22.8917 5.1481L22.8903 4.73994L22.8825 2.5763L22.8814 2.25706L22.879 1.57682L23.1122 1.57682L23.1146 2.25706L22.8814 2.25706L22.8825 2.5763L23.1157 2.5763L23.1234 4.73994L22.8903 4.73994L22.8917 5.1481L23.1249 5.1481L23.127 5.7263L22.98 6.13445L22.5984 6.13445Z",
    fill: "#1592D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1846 6.13445L22.4807 5.93037L22.4779 5.1481L22.4764 4.73994L22.4687 2.5763L22.4676 2.25706L22.4652 1.57682L22.6984 1.57682L22.7008 2.25706L22.4676 2.25706L22.4687 2.5763L22.7019 2.5763L22.7096 4.73994L22.4764 4.73994L22.4779 5.1481L22.7111 5.1481L22.7131 5.7263L22.5662 6.13445L22.1846 6.13445Z",
    fill: "#1592D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8152 6.13445L22.0865 5.93037L22.0837 5.1481L22.0823 4.73994L22.0746 2.5763L22.0734 2.25706L22.071 1.57682L22.2848 1.57682L22.2872 2.25706L22.0734 2.25706L22.0746 2.5763L22.2883 2.5763L22.296 4.73994L22.0823 4.73994L22.0837 5.1481L22.2975 5.1481L22.2996 5.7263L22.165 6.13445L21.8152 6.13445Z",
    fill: "#1592D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4014 6.13445L21.6975 5.93037L21.6947 5.1481L21.6932 4.73994L21.6855 2.5763L21.6844 2.25706L21.682 1.57682L21.9152 1.57682L21.9176 2.25706L21.6844 2.25706L21.6855 2.5763L21.9187 2.5763L21.9264 4.73994L21.6932 4.73994L21.6947 5.1481L21.9279 5.1481L21.9299 5.7263L21.783 6.13445L21.4014 6.13445Z",
    fill: "#1592D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9876 6.13445L21.2836 5.93037L21.2809 5.1481L21.2794 4.73994L21.2717 2.5763L21.2706 2.25706L21.2681 1.57682L21.5013 1.57682L21.5038 2.25706L21.2706 2.25706L21.2717 2.5763L21.5049 2.5763L21.5126 4.73994L21.2794 4.73994L21.2809 5.1481L21.5141 5.1481L21.5161 5.7263L21.3692 6.13445L20.9876 6.13445Z",
    fill: "#1592D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.574 6.13445L20.8701 5.93037L20.8673 5.1481L20.8658 4.73994L20.8581 2.5763L20.857 2.25706L20.8546 1.57682L21.0878 1.57682L21.0902 2.25706L20.857 2.25706L20.8581 2.5763L21.0913 2.5763L21.099 4.73994L20.8658 4.73994L20.8673 5.1481L21.1005 5.1481L21.1025 5.7263L20.9556 6.13445L20.574 6.13445Z",
    fill: "#1592D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1602 6.13445L20.4563 5.93037L20.4535 5.1481L20.452 4.73994L20.4443 2.5763L20.4432 2.25706L20.4408 1.57682L20.6739 1.57682L20.6764 2.25706L20.4432 2.25706L20.4443 2.5763L20.6775 2.5763L20.6852 4.73994L20.452 4.73994L20.4535 5.1481L20.6867 5.1481L20.6887 5.7263L20.5418 6.13445L20.1602 6.13445Z",
    fill: "#1592D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9812 1.54267L19.9812 5.56044L20.202 5.56044L20.202 1.54267L19.9812 1.54267Z",
    fill: "url(#paint2_radial_4618_36182)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1696 2.61786L23.9326 2.61786L23.9328 2.21803L20.1698 2.21803L20.1696 2.61786Z",
    fill: "url(#paint3_radial_4618_36182)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2007 5.14137L23.9873 5.14137L23.9875 4.74154L20.2009 4.74154L20.2007 5.14137Z",
    fill: "url(#paint4_radial_4618_36182)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4618_36182",
    x: 15,
    y: 3,
    width: 9,
    height: 9.23763,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.670833 0 0 0 0 0.670833 0 0 0 0 0.670833 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4618_36182"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4618_36182",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_4618_36182",
    x: 10.4695,
    y: 2.42953,
    width: 9.98193,
    height: 9.81361,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.304167 0 0 0 0 0.304167 0 0 0 0 0.304167 0 0 0 0.52 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4618_36182"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4618_36182",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_4618_36182",
    x: 10,
    y: 2,
    width: 10.9209,
    height: 10.6727,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.725 0 0 0 0 0.725 0 0 0 0 0.725 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4618_36182"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4618_36182",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_4618_36182",
    x: -20,
    y: -28,
    width: 70.9209,
    height: 70.6727,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 17
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.1375 0 0 0 0 0.125698 0 0 0 0 0.125698 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4618_36182"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4618_36182",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4618_36182",
    x1: 12.4737,
    y1: 7.06713,
    x2: 12.4738,
    y2: -0.358566,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00609B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1592D2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_4618_36182",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.5792 3.44398) rotate(-90) scale(3.73079 0.320173)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00609B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1592D2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_4618_36182",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.0916 3.55153) scale(0.110404 1.0989)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B8ACE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1592D2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_4618_36182",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.0512 2.41794) rotate(-89.9691) scale(0.199916 1.02922)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B8ACE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1592D2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_4618_36182",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.0941 4.94146) rotate(-89.969) scale(0.199916 1.03569)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B8ACE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1592D2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4618_36182"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 8,
    fill: "white",
    transform: "translate(24 8) rotate(-180)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClimentIcon);
export default __webpack_public_path__ + "static/media/climentIcon.75d9932ddf0e88acee2b091c27ffb4e1.svg";
export { ForwardRef as ReactComponent };